var link_preview_default = {
  "fontElementMap": "BYuzN",
  "linkPreviewContainer": "_2dZLg",
  "linkPreview": "_8NS8S",
  "linkPreviewImage": "Eq5oc",
  "linkPreviewInfo": "jjuz-",
  "linkPreviewTitle": "bB1wX",
  "linkPreviewDescription": "_53PCD",
  "linkPreviewUrl": "WMcB1"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
